
export default function Program() {
    return <iframe src="https://drive.google.com/file/d/15WdM7LlFqkaf7zn0gC6sIAxCa5mUSaqP/view?usp=drive_link" style={{width: "100%"}} alt='wedding' fluid ></iframe>;
  }